import React from 'react';
import FormLabel from "../../../library/form/components/FormLabel";
import FormSH from "../../../library/form/components/FormSH";
import FormInput from "../../../library/form/components/FormInput";
import FormTimePicker from "../../../library/form/components/FormTimePicker";
import {convertStrToKeyValue} from '../../../helper/uiFunctions';

const DocAttributeRow = (props) => {
    const { formObject, rowKey, viewData, deviceInfo } = props;

    const getInput = () => {
        if (viewData.dataList.inputType === "input") {
            return (
                <FormInput formObject={formObject} rowKey={rowKey} className="uiInput"
                    action={{ InputType: "input", actionId: "refresh", paramName: "input" }} />
            )
        }
        else if (viewData.dataList.inputType === "ac") {

            const viewData = formObject.getFormData(rowKey, "", "input");

            let acDept = viewData.dataList.valLCat > 0 ? "dparam:" + viewData.dataList.valLCat : viewData.dataList.acDepCtrl;
            
            let depAction;
            if(acDept.indexOf(":") > 0)
            {
                depAction = convertStrToKeyValue(acDept, ",", ":");
            }
            else{
                depAction = {"dparam":acDept}
            }
            // console.log("depObj", acDept, viewData.dataList.valLCat, viewData.dataList.acDepCtrl);

            return (
                <FormInput formObject={formObject} rowKey={rowKey} className="uiInputAC"
                    action={{ InputType: "ac", actionId: "refresh", 
                    paramName: "input", acMethod: "%dataList.acMethod", 

                    acDepCtrl: {...depAction, reqPerm: 1} }} />
            )
        }
        else if (viewData.dataList.inputType === "date") {
            return (
                <FormInput formObject={formObject} rowKey={rowKey} className="uiInput"
                    action={{ InputType: "dp", actionId: "refresh", paramName: "input" }} />
            )
        }
        else if (viewData.dataList.inputType === "time") {
            return (
                <FormTimePicker formObject={formObject} rowKey={rowKey} className="uiInput"
                    action={{ actionId: "refresh", paramName: "input" }} />
            )
        }


    }

    return (
        <li className={`list-row uiRow${deviceInfo.activateMobileView ? '1' : formObject.dataList.colCount}Column`}>
            <span className="uiLbl">
                <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "input" }} value="" />
            </span>
            <span className="uiValue">
                <div className="uiValueInput">
                    {
                        getInput()
                    }
                </div>
                <div className="uiValueSH">
                    <FormSH formObject={formObject} rowKey={rowKey}
                        action={{ actionId: "new", paramName: "shLink",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                        >
                    </FormSH>
                </div>
            </span>
        </li>
    )
}

export default DocAttributeRow